module.exports = __webpack_public_path__ + "img/gb9877_1-88-28x47x7.prt.c07f00da.jpg";